<template>
  <div id="tours-search-form" class="tours-search-form">
    <div class="tours-search-form--wrapper">
        <div class="form-group tours-search-form--date-range-wrapper">
          <label>Даты начала туров</label>
          <date-picker
              v-model="date"
              @input="on_change_dates"
              :format="momentFormat"
              :placeholder="tour_dates_placeholder"
              range
          >
          </date-picker>
        </div>

        <div class="form-group tours-search-form--tourists-wrapper">
          <label>Туристы</label>
          <tourists-input :tourists="tourists"
                          @change="on_change_tourists"
          ></tourists-input>
        </div>

        <!--      <b-button variant="secondary">Фильтры</b-button>-->

<!--        <div class="tours-search-form&#45;&#45;submit-wrapper">-->

        <form type="GET" :action="url">
          <input type="hidden" :value="tourists.adults" name="adults"/>
          <input type="hidden" v-for="(age, index) in tourists.kids" :value="age" :name="`kids[]`"/>
          <input type="hidden" :value="date_for_server(date[0])" name="date_from"/>
          <input type="hidden" :value="date_for_server(date[1])" name="date_to"/>
          <input v-if="params.sort" type="hidden" :value="params.sort" name="sort"/>
<!--          <input type="hidden" v-for="(tag, index) in params.tags"   :value="tag" :name="`tags[]`"/>-->

          <transition name="btn-fade">

              <b-button type="submit"
                        :variant="submit_button_style"
                        class="no-label btn-gradient btn-uppercased"
              >
                Показать
              </b-button>
          </transition>
        </form>
<!--        </div>-->

    </div>

  </div>
</template>
<script>
  import DatePicker from 'vue2-datepicker';
  import moment from 'moment';
  import TouristsInput from "./TouristsInput";



  export default {
    components: { TouristsInput, DatePicker },
    props: {
      params: Object,
      url: String,
    },
    data() {
      return {
        state: 'ready',
        // date: [this.date_from_server('07/08/2020'), this.date_from_server('17/08/2020')],
        date: [null, null],
        tourists: {
            adults: 2,
            kids: []
          },
        // Use moment.js instead of the default
        momentFormat: {
          // Date to String
          stringify: (date) => {
            return date ? moment(date).format('LL') : ''
          },
          // String to Date
          parse: (value) => {
            return value ? moment(value, 'LL').toDate() : null
          }
        },
      }
    },
    computed: {
      tour_dates_placeholder(){
        let text = '';
        if ((this.date[0] === null) && (this.date[0] === null)) {
          text = 'Ближайшие туры';
        }
        return text;
      },
      submit_button_style(){
        return (this.state == 'ready') ? 'light' : 'primary'
      }
    },
    beforeMount() {
      moment.locale('ru');
      // console.log(this.params);
      if ((this.params != undefined) && (this.params.adults != undefined) && (this.params.adults > 0)) {
        this.$set(this.tourists, 'adults', this.params.adults);
      }
      if ((this.params != undefined) && (this.params.kids != undefined)) {
        this.$set(this.tourists, 'kids', this.params.kids);
      }
      if ((this.params != undefined) && (this.params.dates != undefined)) {
        let new_dates = [
            this.date_from_server(this.params.dates[0]),
            this.date_from_server(this.params.dates[1])
        ]
        this.$set(this, 'date', new_dates);
      }
    },
    methods: {
      date_for_server(date){
        return (date === null)  ? '' : moment(date).format('L')
      },
      date_from_server(date){
        return (date === null)  ? '' : moment(date, 'L').toDate();
      },
      on_change_dates(value){
        // console.log(value)
        this.$set(this, 'state', 'changed');
      },
      on_change_tourists(tourists){
        this.$set(this, 'state', 'changed');
      },

    }
  }
</script>
<style>
  /* DO NOT REMOVE. This is fix for vue-date-picker */
  .tours-search-form--wrapper {
    opacity: 1;
  }

  /*.btn-fade-enter-active, .btn-fade-leave-active {*/
  /*  transition: opacity .4s, width .2s;*/
  /*  width: 97px;*/
  /*}*/
  /*.btn-fade-enter, .btn-fade-leave-to !* .fade-leave-active below version 2.1.8 *! {*/
  /*  opacity: 0;*/
  /*  width: 0;*/
  /*}*/

</style>